import React, { Component } from 'react';
import styled from 'styled-components';
import Tabs from './_Tabs';
import Options from './_Options';

import HotComponent from './_HotEditableComponent';
import AceComponent from './_AceComponent';
import LibsComponent from './_LibsComponent';
import SettingsModal from './_SettingsModal';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
`

const TabsWrapper = styled.div`
  flex: 0 1 auto;
`

const Title = styled.div`
  flex: 0 1 auto;
  padding: 10px 20px 7px 17px;
  font-size: 1.2em;
  &:hover {
    cursor: ${props => props.owned ? 'pointer' : 'default'};
  }
  width: 100%;
`;

const Mid = styled.div`
  flex: 1 1 auto;
  overflow: auto;
`

const OptionsWrapper = styled.div`
  flex: 0 1 auto;
  ${'' /* position: absolute;
  bottom: 0; */}
  width: 100%;
  border: 1px solid lightgrey;
  border-left: 0;
  border-right: 0;
  border-top: 0;
`

class EditLeft extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: "data",
      aceHeight: 0,
      collapsed: false
    }
  }
  changeTab = (activeTab) => {
    this.setState({ activeTab })
  }
  componentDidMount() {
    window.setTimeout(() => {
      if (this.mid) {
        const aceHeight = this.mid.clientHeight;
        this.setState({ aceHeight })
      }
    }, 100)

  }
  closeModal = (str) => {
    if (this.state.activeModal === str) {
      this.setState({ activeModal: "" });
    }
  }
  renderSettingsPopup = () => {
    this.setState({ activeModal: "settings"})
  }
  render() {


    const hotData   = this.props.envelope ? this.props.envelope.table     : [[]];
    const htmlData  = this.props.envelope ? this.props.envelope.htmlValue : '';
    const cssData   = this.props.envelope ? this.props.envelope.cssValue  : '';
    const jsData    = this.props.envelope ? this.props.envelope.jsValue   : '';
    const libraries = this.props.envelope ? this.props.envelope.libraries : [];

    var editorTab;
    switch(this.state.activeTab) {
      case ("data"):
        editorTab = <HotComponent
          counter={this.props.counter}
          // active={this.props.active}
          hotData={typeof hotData === "undefined" ? [[]] : hotData}
          hotChange={this.props.onHotChange}
        />;
        break;
      case ("html"):
        editorTab = <AceComponent
          codeData={htmlData}
          height={this.state.aceHeight}
          counter={this.props.counter}
          type='html'
          // active={this.props.active}
          codeChange={this.props.onCodeChange}
        />;
        break;
      case ("css"):
        editorTab = <AceComponent
          codeData={cssData}
          height={this.state.aceHeight}
          counter={this.props.counter}
          type='css'
          // active={this.props.active}
          codeChange={this.props.onCodeChange}
        />;
        break;
      case ("javascript"):
        editorTab = <AceComponent
          codeData={jsData}
          height={this.state.aceHeight}
          counter={this.props.counter}
          type='javascript'
          // active={this.props.active}
          codeChange={this.props.onCodeChange}
        />;
        break;
      case ("settings"):
        editorTab = <LibsComponent
          libraries={libraries}
          height={this.state.aceHeight}
          counter={this.props.counter}
          libsChange={this.props.onLibsChange}
        />;
        break;
      default:
        editorTab = null;
    }
    return this.props.collapsed ? (
      <Container>
        <OptionsWrapper style={{paddingTop: '10px', paddingBottom: '10px'}}>
          <Options
            evKey={this.props.evKey}
            ownershipStatus={this.props.ownershipStatus}
            saveEnvelope={this.props.saveEnvelope}
            forkEnvelope={this.props.forkEnvelope}
            deleteEnvelope={this.props.deleteEnvelope}
            changeName={this.props.changeName}
            changeDescription={this.props.changeDescription}
            changeTags={this.props.changeTags}
            envelope={this.props.envelope}
            run={this.props.run}
            collapse={this.props.collapse}
            collapsed={this.props.collapsed}
          />
        </OptionsWrapper>
      </Container>
    ) : (
      <Container>
        <SettingsModal
          saveEnvelope={this.props.saveEnvelope}
          changeName={this.props.changeName}
          changeDescription={this.props.changeDescription}
          changeTags={this.props.changeTags}
          envelope={this.props.envelope}
          open={this.state.activeModal === "settings"}
          closeModal={this.closeModal}
          method="settings"
        />
        <OptionsWrapper>
          <Options
            evKey={this.props.evKey}
            ownershipStatus={this.props.ownershipStatus}
            saveEnvelope={this.props.saveEnvelope}
            forkEnvelope={this.props.forkEnvelope}
            deleteEnvelope={this.props.deleteEnvelope}
            changeName={this.props.changeName}
            changeDescription={this.props.changeDescription}
            changeTags={this.props.changeTags}
            envelope={this.props.envelope}
            run={this.props.run}
            collapse={this.props.collapse}
            collapsed={this.props.collapsed}
          />
        </OptionsWrapper>
        <div onClick={() => {
          if (this.props.ownershipStatus === "new" || this.props.ownershipStatus === "mine") {
            this.setState({ activeModal: "settings"})
        }}}>
          <Title owned={this.props.ownershipStatus === "new" || this.props.ownershipStatus === "mine"}>
            {this.props.envelope ? this.props.envelope.name ? this.props.envelope.name : '...' : '...'}
          </Title>
        </div>
        <TabsWrapper>
          <Tabs
            active={this.state.activeTab}
            buttonClick={this.changeTab}
          >Tabs</Tabs>
        </TabsWrapper>
        <Mid innerRef={(comp) => { this.mid = comp }}>
          {editorTab}
        </Mid>
      </Container>
    )
  }
}

export default EditLeft;



// WEBPACK FOOTER //
// ./src/_EditLeft.js